import * as validator from 'validator'

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg']
const VIDEO_EXTENSIONS = ['mp4', 'mov', 'avi', 'mkv', 'wmv']

export type ValidationResult = {
  state: 'empty' | 'invalid' | 'valid-url' | 'valid-image' | 'valid-base64' | 'invalid-image-not-allowed'
  url: string
}

const isBase64Image = (url: string): boolean => {
  const base64Regex = /^data:image\/(jpeg|jpg|png|gif|webp|svg\+xml);base64,/
  return base64Regex.test(url)
}

const getExtension = (url: string): string | undefined => {
  const parsedUrl = new URL(url)
  return parsedUrl.pathname.split('.').pop()?.toLowerCase()
}

const isValidUrl = (url: string, withVideo?: boolean): boolean => {
  try {
    const extension = getExtension(url)
    return extension
      ? IMAGE_EXTENSIONS.includes(extension) || (!!withVideo && VIDEO_EXTENSIONS.includes(extension))
      : false
  } catch {
    return false
  }
}

const isImage = (url: string) => {
  try {
    const extension = getExtension(url)
    if (isBase64Image(url)) {
      return true
    }
    if (!extension) {
      return false
    }
    return IMAGE_EXTENSIONS.includes(extension)
  } catch {
    return false
  }
}

export const validateImageUrl = (url: string, withVideo?: boolean, onlyVideo?: boolean): ValidationResult => {
  if (!url) {
    return { state: 'empty', url: '' }
  }

  if (isImage(url) && onlyVideo) {
    return { state: 'invalid-image-not-allowed', url }
  }

  if (isBase64Image(url)) {
    return { state: 'valid-base64', url }
  }

  if (!validator.isURL(url)) {
    return { state: 'invalid', url }
  }

  if (!isValidUrl(url, withVideo)) {
    return { state: 'valid-url', url }
  }

  return { state: 'valid-image', url }
}
